import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import { Layout } from '@/layouts/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/application',
    name: 'application',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/application.vue')
  },
  {
    path: '/api',
    name: 'api',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/api.vue')
  },
  {
    path: '/api-reference',
    name: 'api-reference',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
     component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/index.vue'),
    // component: Layout,
    children: [
      {
        path: '/api-reference/response',
        name: 'response',
        component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/response.vue')
      },
      {
        path: '/api-reference/embedding',
        name: 'response',
        component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/embedding.vue')
      },
      {
        path: '/api-reference/sort',
        name: 'sort',
        component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/sort.vue')
      },
      {
        path: '/api-reference/platform',
        name: 'platform',
        component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/platform.vue')
      }
      
    ]

  },
  {
    path: '/experience',
    name: 'experience',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
     component: () => import(/* webpackChunkName: "about" */ '../views/experience/index.vue'),
    // component: Layout,
    children: [
      {
        path: '/experience/dialogue',
        name: 'dialogue',
        component: () => import(/* webpackChunkName: "about" */ '../views/experience/components/response.vue')
      },
      // {
      //   path: '/api-reference/embedding',
      //   name: 'response',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/embedding.vue')
      // },
      // {
      //   path: '/api-reference/sort',
      //   name: 'sort',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/api-reference/components/sort.vue')
      // }
      
    ]

  }

  
]

const router = new VueRouter({
  mode:'hash',// 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
